<template>
  <div class="card tm-workload-card mb-4">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="d-flex align-items-center">
          <div class="icon-box me-3">
            <i class="fas fa-clock text-primary"></i>
          </div>
          <div>
            <h5 class="mb-0 fw-bold text-dark">
              Resumo do Dia — <span class="text-primary">{{ formatDateBr(date) }}</span>
            </h5>
            <div class="d-flex align-items-center mt-1">
              <span class="workload-stats">
                <span class="worked">{{ secondsToHours(workload.worked_total) }}</span>
                <span class="divider">/</span>
                <span class="total">{{ secondsToHours(workload.workload_total) }}</span>
              </span>
              <span v-if="isUnderload" class="badge bg-soft-danger ms-2">Abaixo da Carga</span>
              <span v-else class="badge bg-soft-success ms-2">Carga Completa</span>
            </div>
          </div>
        </div>
        <button class="btn btn-outline-primary btn-por-empresa" @click="$emit('resume')">
          <i class="far fa-building me-2"></i> Horas por empresa
        </button>
      </div>

      <div class="progress-wrapper">
        <div class="progress" style="height: 12px; border-radius: 6px; background: #e9ecef;">
          <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            :style="`width: ${Math.min(workload.percentage_worked, 100)}%`"
            :class="isUnderload ? 'bg-danger' : 'bg-success'"
          ></div>
        </div>
        <span class="percentage-label" :class="isUnderload ? 'text-danger' : 'text-success'">
          {{ Math.abs(workload.percentage_worked || 0).toFixed(1) }}%
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkloadBar',
  props: {
    date: Date,
    workload: Object
  },
  computed: {
    isUnderload() {
      return (this.workload.workload_total - (this.workload.tolerance || 0)) > this.workload.worked_total
    }
  },
  methods: {
    formatDateBr(date) {
      if (!date) return ''
      const d = new Date(date)
      return `${("0" + d.getDate()).slice(-2)}/${("0" + (d.getMonth() + 1)).slice(-2)}/${d.getFullYear()}`
    },
    secondsToHours(seconds) {
      if (!seconds || isNaN(seconds)) return '00:00'
      const h = Math.floor(seconds / 3600)
      const m = Math.floor((seconds % 3600) / 60)
      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
    }
  }
}
</script>

<style scoped lang="sass">
.tm-workload-card
  border: none
  border-radius: 20px
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05)
  background: white
  overflow: hidden

.icon-box
  width: 42px
  height: 42px
  background: rgba(0, 168, 255, 0.1)
  border-radius: 12px
  display: flex
  align-items: center
  justify-content: center
  i
    font-size: 1.2rem

.workload-stats
  font-size: 0.95rem
  font-weight: 600
  .worked
    color: #2d3436
  .divider
    margin: 0 6px
    color: #b2bec3
  .total
    color: #636e72

.bg-soft-danger
  background: #ffebee
  color: #d32f2f

.bg-soft-success
  background: #e8f5e9
  color: #2e7d32

.btn-por-empresa
  border-radius: 10px
  font-weight: 600
  padding: 8px 16px
  border-width: 2px
  &:hover
    background-color: #0d6efd
    color: white

.progress-wrapper
  display: flex
  align-items: center
  gap: 15px

.progress
  flex-grow: 1

.percentage-label
  font-weight: 800
  font-size: 0.9rem
  min-width: 50px
  text-align: right
</style>
